import { createRootRouteWithContext, Outlet } from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools'
import { QueryClient } from '@tanstack/react-query'
import { NotFound } from "@/components/not-found";
import { Toaster } from "@/components/ui/sonner";
import type { AuthState } from '@/types'

interface MyRouterContext {
  queryClient: QueryClient
  auth: AuthState
}

export const Route = createRootRouteWithContext<MyRouterContext>()({
  component: RootComponent,
  notFoundComponent: NotFound,
})

function RootComponent() {
  return (
    <>
      <Outlet />
      <Toaster
        position="top-center"
        expand={true}
        richColors={true}
        closeButton={true}
        toastOptions={{
          style: {
            fontSize: "1.125rem",
            padding: "1.25rem 1.5rem",
            minHeight: "5rem",
            minWidth: "28rem",
          },
        }}
      />
      <TanStackRouterDevtools />
    </>
  )
}
